module.exports = __webpack_public_path__ + "static/media/basicKit__IoT.1396adbc.jpg";